import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  InputLabel,
  MenuItem,
  CircularProgress
} from "@mui/material";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { useEffect, useState } from "react";
import $ from "jquery";
import apiURL from "../../config/environment";
import Select from "@mui/material/Select";
import FormControl from "@mui/material/FormControl";
import { isNumberPositiveInt } from "../../utils";
import CheckIcon from "@mui/icons-material/Check";
import {ScheduleSelect} from "./ScheduleSelect";

export const AddSegmentDialog = ({
  open,
  handleClose,
  existingRows,
  setExistingRows,
    schedules
}) => {
  const [iterisRoute, setIterisRoute] = useState("");
  const [location, setLocation] = useState("");
  const [pmaDensity, setPmaDensity] = useState("");
  const [archived, setArchived] = useState(false);
  const [iterisRouteError, setIterisRouteError] = useState(false);
  const [saveError, setSaveError] = useState(false);
  const [saving, setSaving] = useState(false);
    const [scheduleId, setScheduleId] = useState(null);

  const handleDialogClose = () => {
    setIterisRoute("");
    setLocation("");
    setPmaDensity("");
    setArchived(false);
    setSaveError(false);
    setIterisRouteError(false);
    setScheduleId(null);
    handleClose();
  };

  useEffect(() => {
    isNumberPositiveInt(iterisRoute, "Route ID", setIterisRouteError, true);
  }, [iterisRoute]);

  useEffect(() => {
    if (existingRows.find((row) => row.id === iterisRoute)) {
      setIterisRouteError("Route ID already exists");
    }
  }, [iterisRoute]);

  if (!open) return null;

  const handleSave = () => {
    if (!isNumberPositiveInt(iterisRoute, "Route ID", setIterisRouteError)) {
      return;
    }

    if (existingRows.find((row) => row.id === iterisRoute)) {
      setIterisRouteError("Route ID already exists");
      return;
    }
    setSaving(true);
    const token = JSON.parse(localStorage.getItem("userInfo"))?.token;
    $.ajax({
      method: "POST",
      url: apiURL + "admin/site/iteris",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      contentType: "application/json",
      data: JSON.stringify({
        id: iterisRoute,
        name: location,
        mmaType: pmaDensity,
        archived: archived,
        scheduleId: scheduleId,
      }),
    })
      .done((data) => {
        setSaving(false);
        setExistingRows([...existingRows, data]);
        handleDialogClose();
      })
      .fail((jqXHR, textStatus, errorThrows) => {
        setSaving(false);
        console.error("Error adding Segment", jqXHR, textStatus, errorThrows);
        setSaveError(true);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={() => {
        handleDialogClose();
      }}
    >
      <Box sx={{ width: "444px", padding: "16px 24px 24px 24px" }}>
        <DialogTitle sx={{ padding: 0 }}>New Segment</DialogTitle>
        <DialogContent sx={{ padding: 0 }}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "16px",
            }}
          >
            {saveError && (
              <Alert severity={"error"}>
                Unable to save. Please try again later.
              </Alert>
            )}
            <TextField
              label="Iteris Route"
              type={"text"}
              error={iterisRouteError ? true : false}
              helperText={iterisRouteError}
              value={iterisRoute}
              onChange={(e) => {
                setIterisRoute(e.target.value)

                if (existingRows.find((row) => row.id === iterisRoute)) {
                  setIterisRouteError("Route ID already exists");
                }
              }}
              autoFocus
              fullWidth
            />
            <TextField
              label="Location"
              type={"text"}
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              fullWidth
            />
            <FormControl fullWidth>
              <InputLabel id={"pma-density-label"}>PMA Density</InputLabel>
              <Select
                labelId={"pma-density-label"}
                label="PMA Density"
                onChange={(e) => setPmaDensity(e.target.value)}
                value={pmaDensity}
                fullWidth
              >
                <MenuItem value="Low Density">Low</MenuItem>
                <MenuItem value="Medium Density">Medium</MenuItem>
                <MenuItem value="High Density">High</MenuItem>
              </Select>
            </FormControl>
            <ScheduleSelect
              schedules={schedules}
              value={scheduleId}
              onChange={(e) => setScheduleId(e.target.value)}
            />
          </Box>
        </DialogContent>
        <DialogActions sx={{ padding: 0, marginTop: "16px" }}>
          <Button
            disabled={saving}
            onClick={() => {
              handleDialogClose();
            }}
          >
            Cancel
          </Button>
          <Button
            onClick={handleSave}
            disabled={
              !iterisRoute || !location || !pmaDensity || iterisRouteError || saving
                ? true
                : false
            }
            variant={"contained"}
            sx={{
              backgroundColor: "rgba(19, 151, 203, 1)",
              gap: "8px",
              width: "91.75px",
              height: "36.5px",
            }}
          >
            {saving ? (<CircularProgress size={"24.5px"} />) : (
                <>
                  <CheckIcon sx={{ width: "16px", height: "24px" }} />
                  Save
                </>
            )}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
};
